import { CloseOutlined } from '@ant-design/icons';
import { openNewWindow } from '@flatbiz/utils';
import { FloatButton } from 'antd';
import { useState } from 'react';
import type { BootstrapOptions } from '../../types/layout.js';
import './style.less';

function getEnvUrl(url: string) {
  // 匹配 .qa. 或 .t. 格式
  if (url.includes('.qa.')) {
    return url.replace('.qa.', `.{envName}.`);
  }
  if (url.includes('.t.')) {
    return url.replace('.t.', `.{envName}.`);
  }
  return url;
}

function getCurrentEnv() {
  const host = location.host;
  if (host.includes('dev.flatjs.com') || !!location.port) {
    return 'me';
  }
  if (host.includes('.qa.')) {
    return 'inte';
  }
  if (host.includes('.t.')) {
    return 'rc';
  }
  return 'prod';
}

const getUrlByEnv = (toEnv: 'inte' | 'rc' | 'prod') => {
  const host = location.host;
  const pathname = location.pathname;
  const envUrl = getEnvUrl(`${location.protocol}//${host}${pathname}`);
  if (toEnv === 'inte') {
    return envUrl.replace('.{envName}.', '.qa.');
  }
  if (toEnv === 'rc') {
    return envUrl.replace('.{envName}.', '.t.');
  }
  return envUrl.replace('.{envName}.', '.');
};

export const DevFloatHelp = (props: {
  showProdEnvGuide: BootstrapOptions['showProdEnvGuide'];
  developmentEnvGuideConfigs: BootstrapOptions['developmentEnvGuideConfigs'];
}) => {
  // const layoutCtx = useLayoutCtx();
  const currentEnv = getCurrentEnv();
  // const currentEnv = 'prod';
  const [hidden, setHidden] = useState(false);

  const developmentEnvGuideConfigs = props.developmentEnvGuideConfigs;

  const operateList = [
    {
      label: '测试',
      onClick: () => {
        if (developmentEnvGuideConfigs) {
          openNewWindow(developmentEnvGuideConfigs.inte);
        } else {
          openNewWindow(getUrlByEnv('inte'));
        }
      },
      hidden: () => {
        if (developmentEnvGuideConfigs) return false;
        return currentEnv === 'me';
      },
      active: currentEnv === 'inte',
    },
    {
      label: '预发',
      onClick: () => {
        if (developmentEnvGuideConfigs) {
          openNewWindow(developmentEnvGuideConfigs.rc);
        } else {
          openNewWindow(getUrlByEnv('rc'));
        }
      },
      hidden: () => {
        if (developmentEnvGuideConfigs) return false;
        return currentEnv === 'me';
      },
      active: currentEnv === 'rc',
    },
    {
      label: '生产',
      onClick: () => {
        if (developmentEnvGuideConfigs) {
          openNewWindow(developmentEnvGuideConfigs.prod);
        } else {
          openNewWindow(getUrlByEnv('prod'));
        }
      },
      hidden: () => {
        if (developmentEnvGuideConfigs) return false;
        return currentEnv === 'me';
      },
      active: currentEnv === 'prod',
    },
    {
      label: '开发 文档',
      onClick: () => {
        openNewWindow('https://fex.qa.tcshuke.com/docs/admin/main/intro');
      },
      hidden: () => {
        return currentEnv !== 'me' && currentEnv !== 'inte';
      },
      active: false,
    },
  ];

  if (hidden || (currentEnv === 'prod' && !props.showProdEnvGuide)) {
    return null;
  }

  return (
    <FloatButton.Group shape="square" open={true} style={{ bottom: 50, right: 2, transform: 'scale(0.8)' }}>
      {operateList.map((item, index) => {
        if (item.hidden()) {
          return null;
        }
        return (
          <FloatButton
            key={index}
            description={item.label}
            onClick={item.active ? undefined : item.onClick}
            style={{ cursor: item.active ? 'default' : 'pointer' }}
            type={item.active ? 'primary' : undefined}
            className={item.active ? 'dev-float-help-active' : ''}
          />
        );
      })}
      <FloatButton
        icon={<CloseOutlined />}
        onClick={() => {
          setHidden(true);
        }}
      />
    </FloatButton.Group>
  );
};
